<template>

  <v-card class="restaurant-card">
    <v-img height="200px" v-bind:src="restaurant.pictures[0]"></v-img>
    <v-card-title id="card-title" align="left">
      {{ restaurant.name }}
    </v-card-title>
    <div class="ml-3 font-italic text-sm-body-2">
      {{ restaurant.address }}
    </div>
    <v-rating
      :value="restaurant.rating"
      color="orange"
      background-color="grey"
      half-increments
      readonly
      dense
      class="ml-3"
      size="16"
    ></v-rating>
    <v-card-actions>
      <v-btn id="more-info-button"
             color="primary"
             text
             outlined
      >
        <router-link
          style="text-decoration: none; color: inherit;"
          :to="{
          name: 'Restaurant',
          params: {
            userId: '604cc220ef6fa10004dc0179',
            restaurant: restaurant
            }
          }"
        >More info </router-link>
      </v-btn>
      <v-btn id="delete-button"
             color="red"
             text
             outlined
             @click="$emit('deleteRestaurant',{id: restaurant_id, index: child_number})"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Api from "@/services/api";

export default {
  name: "RestaurantFavoriteCard",
  data() {
    return {
      restaurant: ""
    }

  },

  props: [
    'restaurant_id',
    'favorite_list_id',
    'child_number'
  ],

  methods:{
    destroyElement() {
      // Destroy method
      console.log(`destroy ${this.name}`)
      this.$destroy();
      this.$el.remove();
    }
  },
  async created() {
    this.api = new Api()
    this.restaurant = await this.api.getRestaurantById(this.restaurant_id);

  }
}
</script>

<style scoped>
.restaurant-card {
  position: relative;
}

#more-info-button {
  font-family: Arial, Helvetica, sans-serif;
}

#card-title {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}


</style>
